import React from 'react';

interface SettingsPageToolbarContextInterface {
  setToolbarActions: (actions: React.ReactNode) => React.ReactNode;
  toolbarActions: React.ReactNode;
}

export const SettingsPageToolbarContext = React.createContext<
  SettingsPageToolbarContextInterface
>({
  setToolbarActions: () => null,
  toolbarActions: null,
});

const { Provider } = SettingsPageToolbarContext;

export const SettingsPageToolbarContextProvider = ({ children }) => {
  const [toolbarActions, setToolbarActions] = React.useState<React.ReactNode>(
    null,
  );

  return (
    <Provider value={{ toolbarActions, setToolbarActions }}>
      {children}
    </Provider>
  );
};
